export default "__VITE_ASSET__9d486199__"